<template>
	<div></div>
</template>

<script>
	import { Notify } from 'vant';
	export default{
		methods:{
			getWxUser(){
				let search = location.search.slice(1);
				let arr = search.split("&");
				let result = {};
				arr.forEach(function(item){
					let itemArr = item.split("=");
					result[itemArr[0]]=itemArr[1]
				})
				if(result.code){
					let code=result.code
					let _this = this
					this.request.postURL("/api/user/wxLoginGroupH5",{
						code:code,
						device_id:"2021WAP"
					}).then(function(res){
						console.log(res)
						if(res.data.code == 1){
							Notify({
							  type:"danger",
							  message: '登录成功',
							  duration: 1000,
							})
							// 拿到token
							let userToken = res.data.data.token
							// 存储token
							_this.$store.commit('setToken',userToken)
							//获取用户数据
							_this.$store.dispatch('getUserAsync')
							//跳转到用户中心页
							 _this.$router.push('/userCenter');
							
						}
						else{
							_this.$router.push('/userCenter');
						}					
						
					}).catch(function(error){
						_this.$router.push('/userCenter');
					})
				}
			}
		},
		created() {
			if(!this.$store.state.token){
				this.getWxUser()
			}
			else{
				this.$router.push('/userCenter');
			}
		},	
	}
</script>

<style>
</style>
